import type { simulation } from "@/features/dashboard/types.api";
import axiosInstance from "@/lib/axios";
import type { paginatedResponse } from "@/types/api/paginated.api";

export const getAssignedSimulations = async (
    userId: string,
): Promise<simulation[]> => {
    const { data } = await axiosInstance.get<simulation[]>(
        `/users/${userId}/assigned-simulations/`,
    );
    return data;
};

export const getAvailableSimulations = async (
    userId: string,
    filters: any,
): Promise<paginatedResponse<simulation>> => {
    const { data } = await axiosInstance.get<paginatedResponse<simulation>>(
        `/simulations/`,
        { params: { ...filters, exclude_user_id: userId, state: "published" } },
    );
    return data;
};

export const assignSimulation = async (
    userId: string,
    simulationId: number | string,
): Promise<void> => {
    const { data } = await axiosInstance.post<void>(
        `/users/${userId}/assigned-simulations/`,
        { simulation_id: simulationId },
    );
    return data;
};

export const unassignSimulation = async (
    userId: string,
    simulationId: number | string,
): Promise<void> => {
    return axiosInstance.delete(
        `/users/${userId}/assigned-simulations/`,
        { params: { simulation_id: simulationId } }
    );
};

export const resetSimulationAttempt = async (
    userId: string,
    simulationId: number | string
): Promise<void> => {
    await axiosInstance.post(
        `/reports/manage/student/${userId}/simulation/${simulationId}/reset/`
    ); 
};
